import sportsApi from './sportsApi';
import { SocialBenchmarkingResponse } from '@app/types/internal';

export const getSocialBenchmarkingData = async (
    clientId,
    favoriteIds,
    leagueIds,
    periodicity,
    mediaTypes,
    platformIds,
    accountTypes,
    startDate = null,
    endDate = null,
    shouldGroupBy = true,
    visualization = null,
) => {
    const showByLeagues = leagueIds && leagueIds.length;
    const showByFavorites = favoriteIds && favoriteIds.length;

    const socialBenchmarkingData =
        showByLeagues || showByFavorites
            ? await sportsApi
                  .url(`/clients/${clientId}/social-benchmarking`)
                  .query({
                      ...(showByFavorites
                          ? {
                                favoriteId: favoriteIds[0],
                            }
                          : {
                                leagueId: leagueIds[0],
                            }),
                      periodicity,
                      mediaTypeIds: mediaTypes,
                      platformIds,
                      accountTypeIds: accountTypes,
                      ...(shouldGroupBy && { groupBy: visualization }),
                      ...(periodicity == 'custom' && { startDate, endDate }),
                  })
                  .get()
                  .json()
            : {
                  startDate: '',
                  endDate: '',
                  accountGroupsData: [],
              };

    return socialBenchmarkingData as SocialBenchmarkingResponse;
};
